<template>
    <div name="hero" class="hero" id="hero">
		<div ref="slider" class="slider" @touchstart="startTouch" @touchend="endTouch"  @touchmove="moveTouch" @wheel="handleScroll">
            <div class="section section1">
				<div class="video-area">
                    <video autoplay muted loop playsinline class="bg-video">
                        <source src="../../assets/renew_mobile/soldoc_main_m.mp4" type="video/mp4">
                    </video>
                </div>
                <img class="logo" src="../../assets/renew_mobile/soldoc_logo.png" alt="soldoc+ logo"/>
				<div class="inner">
                    <div class="title-wrap">
                        <span class="title">
                            <span class="bold-title">모든 진료의 시작, 솔닥</span><br>
                            <span class="sub-text">진료 예약부터 처방, 진료 관리까지<br>기다림 없이 한 번에</span>
                        </span>
                        <a href="https://soldoc.onelink.me/fbp3/mme6qztn" target="_blank" title="새창으로 열림" class="btn-tele-main">
                            <span class="text">앱 다운로드</span>
                        </a>
                    </div>
                </div>
                <button class="btn-section-mouse" @click="buttonClick">
                    <img class="section-mouse" src="../../assets/renew_mobile/img_mouse_arrow.png" alt="아래로 이동">
                    <img class="mouse-arrow" src="../../assets/renew_mobile/img_chevron_down.png" alt="아래로 이동">
                </button>
            </div>

            <div class="section section2">
                <div class="inner">
                    <div class="copyright">
                        <div class="inner-div">
                            <strong class="copyright-text">
                                <span>왜 아직도</span>
                                <span class="copyright-ani">
                                    <div class="ani">
                                        <div :ref="aniRef" class="ani-content">
                                            <span v-for="item in animatedTexts" :key="item.id">{{ item.text }}</span>
                                        </div>
                                    </div>
                                </span>
                                <span>기다려야 하나요?</span>
                            </strong>
                        </div>
                    </div>
                </div>
            </div>

			<div class="section section3">
				<div class="inner">
                    <div class="intro-text text0">
                        <strong class="tit">기다림 없이 <br><span class="text-primary">바로예약</span></strong>
                        <span class="sub-title">진료 가능한 내 주변 병원을 찾고<br/>바로솔닥으로 간편하게 예약해요</span>
                    </div>
                    <div class="intro-image image0">
                        <img src="../../assets/renew_mobile/img_app_map.png" alt="바로솔닥 어플 주변병원 찾기"/>
                    </div>
                </div>
			</div>
			<div class="section section4">
				<div class="inner">
                    <div class="intro-text text1">
                        <strong class="tit">기다림 없이 <br><span class="text-primary">바로진료</span></strong>
                        <span class="sub-title">예약한 시간에 맞춰 방문하면<br>대기 없이 진료를 볼 수 있어요</span>
                    </div>
                    <div class="intro-image image1">
                        <img src="../../assets/renew_mobile/img_app_timetable.png" alt="바로솔닥 어플 진료예약"/>
                    </div>
                </div>
			</div>
			<div class="section section5">
				<div class="inner">
                    <div class="intro-text text2">
                        <strong class="tit">기다림 없이 <br><span class="text-primary">바로결제</span></strong>
                        <span class="sub-title">진료 후 수납을 위한 대기 없이<br/>앱에서 간편하게 결제할 수 있어요</span>
                    </div>
                    <div class="intro-image image2">
                        <img src="../../assets/renew_mobile/img_app_pay.png" alt="바로솔닥 어플 간편 결제"/>
                    </div>
                </div>
			</div>
			<div class="section section6">
				<div class="inner">
                    <div class="intro-text text3">
                        <strong class="tit">기다림 없이 <br><span class="text-primary">바로발급</span></strong>
                        <span class="sub-title">서류는 앱에서 언제든지 확인하고<br>다운로드 받을 수 있어요</span>
                    </div>
                    <div class="intro-image image3">
                        <img src="../../assets/renew_mobile/img_app_doc.png" alt="바로솔닥 어플 필요서류"/>
                    </div>
                </div>
			</div>
        </div>
    </div>
</template>

<script>
export default {
    name:'hero',
	data() {   
		return {
			currentIndex: 0,
			startY: 0,
			endY: 0,
			scrolling: false,
			animatedTexts: [
				{ id: 1, text: '병원에서' },
				{ id: 2, text: '결제를' },
				{ id: 3, text: '서류발급을' },
				{ id: 4, text: '병원에서' }
			],
			aniRef: 'aniDiv'
		}
	},
	mounted() {
        document.addEventListener('touchmove', this.moveTouch, { passive: false });
        document.addEventListener('moveToSlide', this.moveToSlide);
        this.setVhProperty();
        window.addEventListener('resize', this.setVhProperty);
	},
    beforeDestroy() {
        document.removeEventListener('touchmove', this.moveTouch);
        window.removeEventListener('resize', this.setVhProperty);
    },
    methods: {
        moveToSlide(event) {
            this.currentIndex = event.detail.index;
            this.updateSlider();
        },
        setVhProperty() {
            if (window.scrollY !== 0) return;
            let vh = window.innerHeight * 0.01;
            document.documentElement.style.setProperty('--vh', `${vh}px`);
        },
        goKakao: function()
        {
            window.criteo_q = window.criteo_q || [];
            var deviceType = /iPad/.test(navigator.userAgent) ? "t" : /Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Silk/.test(navigator.userAgent) ? "m" : "d";
            window.criteo_q.push(
                { event: "setAccount", account: 96598},

                // To Do 1. 현재 유저의 이메일 주소(공백 제거 및 소문자로 변환 후) 전달. 유저의 이메일을 알수 없는 상황이면 빈 문자열로 전달
                { event: "setEmail", email: "##User Email##" },

                // To Do 2. 현재 유저의 저장된 배송지 우편번호. 유저의 배송지 우편번호를 알수 없는 상황이면 빈 문자열로 전달
                { event: "setZipcode", zipcode: "##Zip Code##" },

                { event: "setSiteType", type: deviceType},

                // To Do 3. 확인 또는 주문 번호를 전달
                // Tip 1. 다른 종류의 전환일 경우 상품 ID에 다른 값으로 전달하여 나중에 리포트를 통해 확인 가능
        
                { event: "trackTransaction", id: Math.floor(Math.random()*99999999999), item: [
                    {id: "1", price: 1, quantity: 1 }
                ]}
            );

            window.open('https://plus.kakao.com/talk/bot/@솔닥/솔닥%20원격진료%20시작하기', '_blank');
        },

		startTouch(event) {
            this.startY = event.touches[0].clientY;
        },
        moveTouch(event) {
            if (!event.cancelable) return;

            var moveY = event.touches[0].clientY;
            var diff = this.startY - moveY;
			
            if (window.scrollY !== 0) return;
            if (this.currentIndex === 5 && diff > 0) {
                return;
            }
            if (this.currentIndex === 0 && diff < 0) {
                return;
            }

            event.preventDefault();
        },
        endTouch(event) {
            this.endY = event.changedTouches[0].clientY;
            var diff = this.startY - this.endY;
            if (diff > 50 && this.currentIndex < 5) {
                this.currentIndex++;
                this.updateSlider();
            } else if (diff < -50 && this.currentIndex > 0) {
                this.currentIndex--;
                this.updateSlider();
            }
        },
		handleScroll(event) {
            if (this.scrolling) return;

            this.scrolling = true;
            setTimeout(() => {
                this.scrolling = false;
            }, 400);

            if (event.deltaY > 0 && this.currentIndex < 5) {
                event.preventDefault();
                this.currentIndex++;
            } else if (event.deltaY < 0 && this.currentIndex > 0) {
                event.preventDefault();
                this.currentIndex--;
            }
            this.updateSlider();
        },
        buttonClick() {
            if (this.currentIndex < 5) {
                this.currentIndex++;
                this.updateSlider();
            }
        },
        lastButtonClick() {
            const featureElement = document.getElementById('feature');
            const rect = featureElement.getBoundingClientRect();
            const absoluteTop = window.scrollY + rect.top;
            const targetPosition = absoluteTop + 84;
            window.scrollTo({
                top: targetPosition,
                behavior: 'smooth'
            });
        },
		updateSlider() {
            // var slider = this.$refs.slider;
            // slider.style.transform = `translateY(-${this.currentIndex * 100 / 6}%)`;
            const vhInPixels = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--vh'));
            const pageHeightInPixels = 100 * vhInPixels;
            const translateYValue = this.currentIndex * pageHeightInPixels;
            var slider = this.$refs.slider;
            slider.style.transform = `translateY(-${translateYValue}px)`;

			if(this.currentIndex === 1) {
				$('.copyright-text').css('display', 'flex');
                $('.section2 .ani').addClass('start-ani');
			} else {
				$('.copyright-text').css('display', 'none');
                $('.section2 .ani').removeClass('start-ani');
			}
			if(this.currentIndex === 2) {
				$('.intro-text.text0').css('display', 'block');
				$('.intro-image.image0').css('display', 'flex');

			} else {
				$('.intro-text.text0').css('display', 'none');
				$('.intro-image.image0').css('display', 'none');
			}
			if(this.currentIndex === 3) { 
				$('.intro-text.text1').css('display', 'block');
				$('.intro-image.image1').css('display', 'flex');
			} else {
				$('.intro-text.text1').css('display', 'none');
				$('.intro-image.image1').css('display', 'none');
			}
			if(this.currentIndex === 4) { 
				$('.intro-text.text2').css('display', 'block');
				$('.intro-image.image2').css('display', 'flex');
			} else {
				$('.intro-text.text2').css('display', 'none');
				$('.intro-image.image2').css('display', 'none');
			}
			if(this.currentIndex === 5) { 
				$('.intro-text.text3').css('display', 'block');
				$('.intro-image.image3').css('display', 'flex');
			} else {
				$('.intro-text.text3').css('display', 'none');
				$('.intro-image.image3').css('display', 'none');
			}
        },
    }
}
</script>

<style scoped>
	.hero{
		position: relative;
		display: flex; 
		flex-direction: column;
		justify-content: flex-start;
		align-items: center;
		width: 100%;
        /* height: 100%;
        max-height: 100%; */
        height: calc(100 * var(--vh));
        max-height: calc(100 * var(--vh));
		overflow: hidden;
    } 
    .slider {
		width: 100%;
		/* transform: translateY(0vh); */
		transform: translateY(0%);
        transition: transform 0.3s ease-in-out;
    }
	.section{
        position: relative;
        display: block;
        width: 100%;
        height: 100%;
        height: calc(100 * var(--vh));
        overflow: hidden;
    }
	.section .inner{
        position: absolute;
        top: 50%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-items: center;
        width: 100%;
        /* height: 100%; */
        transform: translateY(-50%);
    }
	.section1{
        position: relative;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		/* height: 100vh; */
        /* height: 100%; */
	}
	.section1::after{
		content: "";
        position: absolute;
        top: 0;
        left: 0;
        display: block;
		width: 100%;
        height: 100%;
		background: url(../../assets/renew_pc/bg_barosoldoc01.jpg);
		z-index: -10;
    }
	.section1 .logo{
		position: absolute;
		top: 33px;
	}
    .bg-video {
        position: absolute;
        /* position: fixed; */
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        object-fit: cover;
    }
	.video-area{
        /* position: fixed; */
        position: absolute;
		width: 100%;
		height: 100%;
        z-index: -1;
    }
    .video-area::after{
        content: "";
        position: fixed;
        top: 0;
        left: 0;
        display: block;
        width: 100%;
		height: 100%;
        background: rgba(0, 0, 0, 0.25);
    }

    .logo {
        width: 71px;
    }
    .title-wrap{
        position: absolute;
        top: 50%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-items: center;
        transform: translateY(-50%);
    }
    .title {
        font-weight: 200;
        color: #fff;
        text-align: center;
		animation: fadeInUp 1s;
    }

	.bold-title {
        font-weight: 600;
        font-size: 34px;
        line-height: 46px;   
    }
    .sub-text{
        display: block;
        margin-top: 15px;
		font-size: 16px;
        font-weight: 400;
    }

	.btn-tele-main {
        display: flex;
        justify-content: space-around;
        align-items: center;   
        width: 150px;
        height: 46px;
        margin-top: 32px;
        padding-top: 1px;
        padding-left: 19.66px;
        padding-right: 19.66px;
        border-radius: 6px;
        background: #008DEF;
        font-weight: 500;
        font-size: 17px;
        color: #fff;
		line-height: 1;
		text-decoration: none;
		animation: fadeInUp 1s;
    }
	.btn-tele-main .text{
        position: relative;
    }
    .btn-tele-main:hover{
        background: #fff;
		color: #008DEF;
    }
    .btn-section-mouse{
        position: absolute;
        left: 50%;
        bottom: 25px;
        transform: translate(-50%);
        display: flex;
        flex-direction: column;
        width: 24px;
        height: 62px;
        margin: 0;
        padding: 0;
        background: none;
        border: none;
        z-index: 20;
    }
    .section-mouse{
        position: relative;
        display: block;
        width: 24px;
        height: 38px;
        height: auto;
    }
    .mouse-arrow{
        /* position: absolute;
        top: 0;
        left: 0; */
        display: block;
        width: 24px;
        height: 24px;
        transform-origin: 0px 0px;
        transform: translate(0, 0);
        animation: scroll-down 900ms ease-in-out infinite;
    }

    @keyframes scroll-down {
        0% {
        transform: translate(0, 0px);
        }
        30% {
        transform: translate(0, -5px);
        }       
        45% {
        transform: translate(0, 0px);
        }
        100% {
        transform: translate(0, 0px);
        }
    }

    .section2{
        width: 100%;
        background: url(../../assets/renew_mobile/bg_barosoldoc02.jpg);
        background-size: cover;
        background-repeat: no-repeat;
    }
	.copyright{
        display: flex;
        justify-content: center;
        align-items: center;
		width: 100%;
		height: 100%;
    }

	.inner-div {
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        width: 100%;
        height: 100%;
    }

	.copyright-text{
        display: flex;
        display: none;
        flex-direction: column;
        align-items: center;
		padding-bottom: 50px;
		font-size: 32px;
        font-weight: 600;
        text-align: center;
        color: #fff;
		animation: fadeInUp 1s;
    }

	.copyright-ani{
        position: relative;
        display: inline-flex;
        flex-direction: column;
        width: 175px;
        height: 39px;
        margin: 7px 15px 14px;
		font-size: 32px;
        line-height: 1.4;
        text-align: center;
        overflow: hidden;
    }

	.copyright-ani::before{
        position: absolute;
        left: 0;
        content: "[";
        font-weight: 400;
        color: #008DEF;
    }
    .copyright-ani::after{
        position: absolute;
        right: 0;
        content: "]";
        font-weight: 400;
        color: #008DEF;
    }

	.section3,.section4,.section5,.section6{
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
        /* height: 100vh; */
		background: #fff;
	}
	.intro-text{
        flex: 0 0 auto;
		display: none;
        height: 194px;
		padding-top: 30px;		
        animation: fadeInUp2 1s;
	}

	.section .tit{
		display: block;
		flex-direction: column;
        font-weight: 600;
        font-size: 32px;
        line-height: 44px;
        color: #1A1A1A;
		text-align: center;
    }
	.section .sub-title{
		display: block;
        margin-top: 16px;
        font-weight: 400;
		font-size: 16px;
        line-height: 24px;
        color: #666;
        text-align: center;
    }

	.intro-image{
		flex: 1 1 auto;
		display: none;
		align-items: center;
		justify-content: center;
		justify-items: center;
        max-width: 266px;
		max-height: 548px;
        padding: 10px 0 60px;
        background-size: contain;
		height: calc(100vh - 244px);
        animation: fadeInUp1 1s;
    }
	
	.intro-image img{
        height: 100%;
		margin: 0 auto;
		background-position: center;
		background-size: contain;
	}


	.ani{
        position: absolute;
    }
    .start-ani {
        animation: slideUp 12s linear infinite;
    }
	@keyframes slideUp {
        0%, 10% {
            top: 0;
        }
        25%, 40% {
            top: -1.48em;
        }
        55%, 70% {
            top: -2.96em;
        }
        85%, 99.98% {
            top: -4.44em;
        }
        99.99%, 100% {
            top: 0;
        }
    }

    .ani-content {
        display: flex;
        flex-direction: column;
    }
    .ani-content span{
        display: inline-block;
		width: 175px;
        height: 1.48em;
        line-height: 1.5;
        text-align: center;
    }
	

@media screen and (max-width: 360px){
    .title {
        font-weight: 200;
        color: #fff;
        text-align: center;
    }
    .bold-title {
        font-weight: 600;
        font-size: 23px;
        line-height: 46px;   
    }
    .sub-text{
        margin-top: 15px;
        font-size: 16px;
        font-weight: 400;
    }

    .section .tit {
        font-weight: 600;
        font-size: 23px;
        line-height: 1.5;   
    }
    .section .sub-title{
        margin-top: 10px;
        font-size: 14px;
        font-weight: 400;
        line-height: 1.4;   
        text-align: center;
    }

    .intro-text{
        flex: 0 0 auto;
        height: 158px;
		padding-top: 30px;		
	}
    .intro-image{
        padding-top: 20px;
    }
}

	@keyframes fadeInUp {
        0% {
            opacity: 0;
            transform: translate3d(0, 100%, 0);
        }
        100% {
            opacity: 1;
            transform: translate3d(0, 0%, 0);
        }
    }

	@keyframes fadeInUp1 {
        0% {
            opacity: 0;
            transform: translate3d(0, 100%, 0);
        }
        to {
            opacity: 1;
            transform: translate3d(0, 0%, 0);
        }
    }
    @keyframes fadeInUp2 {
        0% {
            opacity: 0;
            transform: translate3d(0, 130%, 0);
        }
        to {
            opacity: 1;
            transform: translate3d(0, 0%, 0);
        }
    }

    @keyframes fadeUp {
        0% {
            opacity: 0;
            transform: translate3d(0, 100%, 0);
        }
        to {
            opacity: 1;
            transform: translateZ(0);
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/mobile_main/Hero.vue